export default __webpack_public_path__ + "static/media/28.643abaa1.jpg";